export default {
	showAuth: false,
	showAuthModel: false,
	showForgetPassword: false,
	showAgreementContentModel: false,
	showChangePassword: false,
	setAgreeContentModelValue: false,
	
}
